<template>
  <div v-if="initialized" class="login">
    <div class="main_box">
      <div class="contents">
        <LoginArea></LoginArea>
      </div>
    </div>
  </div>
</template>
  
<script>
import LoginArea from '@/components/login/LoginArea.vue'
import Api from '@/lib/Api.js'

const defSCHEDULE = [

];

export default {
  name: 'loginView',
  components: {
    LoginArea,
  },
  data() {
    return {
      initialized: false,
    }
  },
  created() {
  },
  async mounted() {
    this.status = await Api.getStatus(this)
    if (this.status.login_status == "LOGGED_IN") {
      this.$router.push("/")
    }
    this.initialized = true
  },
  methods: {
  },
}
</script>

<style scoped>

</style>